import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import PaymentList, { DispatchProps, OwnProps, StateProps } from './PaymentList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getPayments } from 'src/store/actions/payment-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.payments.data,
        inProgress: state.payments.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getPayments(params)),
    };
}

const PaymentListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentList);

export default PaymentListScreen;
